import {
  NbThemeModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';

export function provideNbTheme() {
  return [
    ...NbThemeModule.forRoot({ name: 'dark' }).providers ?? [],
    ...NbSidebarModule.forRoot().providers ?? [],
    ...NbMenuModule.forRoot().providers ?? [],
    ...NbToastrModule.forRoot().providers ?? [],
    ...NbWindowModule.forRoot().providers ?? [],
    ...NbDialogModule.forRoot().providers ?? [],
    ...NbDatepickerModule.forRoot().providers ?? [],
    ...NbSidebarModule.forRoot().providers ?? [],
  ];
}
